/*
  HAPPE BOX V3 - Animation Controller Module (theme-animation.js)
*/

class HappeAnimationController {
  fadeIn(element, duration = 200) {
    if (!element) return;
    element.style.opacity = 0;
    element.style.display = 'block';
    element.style.transition = `opacity ${duration}ms ease`;
    setTimeout(() => {
      element.style.opacity = 1;
    }, 10);
  }

  fadeOut(element, duration = 200) {
    if (!element) return;
    element.style.transition = `opacity ${duration}ms ease`;
    element.style.opacity = 0;
    setTimeout(() => {
      element.style.display = 'none';
    }, duration);
  }
}

window.HappeAnimationClass = HappeAnimationController;
